"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniProviderBookAndReferCard = void 0;
var MiniProviderBookAndReferCard_1 = require("./MiniProviderBookAndReferCard");
Object.defineProperty(exports, "MiniProviderBookAndReferCard", { enumerable: true, get: function () { return __importDefault(MiniProviderBookAndReferCard_1).default; } });
//# sourceMappingURL=index.js.map